import $axios from '@/store/axios-instance.js';

export const moduleName = 'knowledgeBase'

export const mutationType = {
    retrieveList : `[${moduleName}] retrieveList`,
    retrieveItem : `[${moduleName}] retrieveItem`,
    insert: `[${moduleName}] insert`,
    update: `[${moduleName}] update`,
    delete: `[${moduleName}] delete`,

    documentList: `[${moduleName}] documentList`,
    addDocument: `[${moduleName}] addDocument`,
    deleteDocument: `[${moduleName}] deleteDocument`,
}

export const actionType = {
    retrieveList : `[${moduleName}] retrieveList`,
    retrieveItem : `[${moduleName}] retrieveItem`,
    create: `[${moduleName}] create`,
    store: `[${moduleName}] store`,
    delete: `[${moduleName}] delete`,

    documentList: `[${moduleName}] documentList`,
    attachDocument: `[${moduleName}] attachDocument`,
    downloadDocument: `[${moduleName}] downloadDocument`,
    deleteDocument: `[${moduleName}] deleteDocument`,
    attachImage: `[${moduleName}] attachImage`,
}

export const getterType = {
    list: `[${moduleName}] list`,
    listTotal: `[${moduleName}] listTotal`,
    currentItem: `[${moduleName}] currentItem`,
}

export default {
    state: {
        knowledgeBaseList: null,
        currentKnowledge: null
    },
    mutations: {
        [mutationType.retrieveList](state, entityList) {
            state.knowledgeBaseList = entityList
        },
        [mutationType.retrieveItem](state, entity) {
            state.currentKnowledge = entity
        },
        [mutationType.insert](state, payload) {
            let entity = state.currentKnowledge

            Object.assign(entity, payload);
        },
        [mutationType.update](state, payload) {
            let entity = state.currentKnowledge

            Object.assign(entity, payload);
        },
        [mutationType.delete](state) {
            state.currentKnowledge = null
        },

        [mutationType.documentList](state, entity) {
            if(state.currentKnowledge){
                state.currentKnowledge.documents = entity
            }
        },
        [mutationType.addDocument](state, entity) {
            if(state.currentKnowledge){
                if(!Array.isArray(state.currentKnowledge.documents))
                {
                    state.currentKnowledge.documents = []
                }
                state.currentKnowledge.documents.push(entity)
            }
        },

        [mutationType.deleteDocument](state, entity) {
            if(state.currentKnowledge){
                let entityIndex = state.currentKnowledge.documents.findIndex(function (item) {
                    return item.id === entity
                })
                if (entityIndex > -1) {
                    state.currentKnowledge.documents.splice(entityIndex, 1)
                }
            }
        },
    },
    actions: {
        [actionType.retrieveList](context, payload){
            return new Promise((resolve, reject) => {
                $axios
                    .get('knowledgebase', {
                        params: {
                            limit: payload.limit,
                            offset: payload.offset,
                            search: payload.search
                        }
                    })
                    .then(response => {
                        context.commit(mutationType.retrieveList, response.data)

                        resolve(response.data)
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
        [actionType.retrieveItem](context, payload){
            return new Promise((resolve, reject) => {
                if(!payload){
                    context.commit(mutationType.retrieveItem, null)
                    resolve()
                } else {
                    $axios
                        .get(`knowledgebase/${payload}`)
                        .then(response => {
                            context.commit(mutationType.retrieveItem, response.data)

                            resolve(response.data)
                        })
                        .catch(error => {
                            console.log(error)
                            reject(error)
                        })
                }
            })
        },
        [actionType.create](context, payload){
            return new Promise((resolve, reject) => {
                $axios
                    .post(`knowledgebase`, {
                        id: payload.id,
                        articleNo: payload.articleNo,
                        name: payload.name,
                        issue: payload.issue,
                        solution: payload.solution
                    })
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
        [actionType.store](context, payload){
            return new Promise((resolve, reject) => {
                $axios
                    .put(`knowledgebase`, {
                        id: payload.id,
                        articleNo: payload.articleNo,
                        name: payload.name,
                        issue: payload.issue,
                        solution: payload.solution
                    })
                    .then((response) => {
                        context.commit(mutationType.update, response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
        [actionType.delete](context, payload){
            return new Promise((resolve, reject) => {
                $axios
                    .delete(`knowledgebase/${payload}`)
                    .then(() => {
                        context.commit(mutationType.delete, payload)
                        resolve()
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },

        [actionType.documentList](context, payload){
            return new Promise((resolve, reject) => {
                $axios
                    .get(`knowledgebase/${payload.id}/documents`)
                    .then(response => {
                        context.commit(mutationType.documentList, response.data)

                        resolve()
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
        [actionType.downloadDocument](context, payload){
            return new Promise((resolve, reject) => {
                $axios
                    .get(`filestorage/knowledgebase/${payload.id}/documents/${payload.fileName}`, {
                        responseType: 'blob'
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
        [actionType.deleteDocument](context, payload){
            return new Promise((resolve, reject) => {
                $axios
                    .delete(`knowledgebase/${payload.id}/documents/${payload.documentId}`)
                    .then(() => {
                        context.commit(mutationType.deleteDocument,payload.documentId)
                        resolve()
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
        [actionType.attachDocument](context, payload){
            return new Promise((resolve, reject) => {

                try {
                    if (payload.file) {
                        let i = 0
                        payload.file.forEach(file => {
                            let formData = new FormData()
                            formData.append('file', file)
                            formData.append('documentId', payload.documentId[i++])
                            formData.append('description', '')

                            $axios
                                .post(`knowledgebase/${payload.id}/documents`, formData)
                                .then(response => {
                                    context.commit(mutationType.addDocument, response.data)
                                    resolve()
                                })
                                .catch(error => {
                                    console.log(error)
                                    reject(error)
                                })
                        })
                        resolve()
                    }
                } catch (error) {
                    console.log(error)
                    reject(error)
                }
            })
        },
        [actionType.attachImage](context, payload){
            return new Promise((resolve, reject) => {
                try {
                    let formData = new FormData()
                    formData.append('image', payload.file)

                    $axios
                        .post(`knowledgebase/${payload.id}/images`, formData)
                        .then(response => {
                            resolve(response.data)
                        })
                        .catch(error => {
                            console.log(error)
                            reject(error)
                        })
                } catch (error) {
                    console.log(error)
                    reject(error)
                }
            })
        },
    },
    getters: {
        [getterType.list](state){
            return state.knowledgeBaseList ? state.knowledgeBaseList.knowledgeBaseArticles : []
        },
        [getterType.listTotal](state){
            return state.knowledgeBaseList ? state.knowledgeBaseList.rowsCount : 0
        },
        [getterType.currentItem](state){
            return state.currentKnowledge
        }
    }
}